import {Button} from '@material-ui/core';
import { Grid, TextField,CircularProgress,Typography,Divider} from "@material-ui/core";
import {useHistory} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {checkValidityOfBriefLink,LOAD_BRIEF_PAGE_TEXT} from '../../utility';
import { useLocation } from "react-router-dom";

const UiInput = makeStyles({
  root : {
    width: '80%',
    "& .MuiInputBase-input": {
        borderRadius: '4px',
        border: 'none',
        boxShadow: '0px 1px 6px #7784945e',
        padding: '5px 10px',
        margin: 0
    },
    "& .MuiInputBase-input:focus": {
        boxShadow:'none',
        outline:'none'
    },
    "& .MuiFormLabel-root":{
      textAlign:'center',
      width:'max-content'
    }
  }
});

function LoadBriefForm(props){
    const uiInputClass = UiInput();
    const history = useHistory();
    const [sLoadBrief, setLoadBrief] = React.useState();
    const location = useLocation();
    const [briefLoadInProgress, setBriefLoadInProgress] = React.useState(false);

    const briefDispatch = () => {
      if(sLoadBrief.length > 0){
        try{
          setBriefLoadInProgress(true);
          const id = new URL(sLoadBrief).pathname.split("/")[2];
          checkValidityOfBriefLink(id).then((valid) => {
            if(!valid){
              setBriefLoadInProgress(false);
              location.state.openSnackbar(LOAD_BRIEF_PAGE_TEXT.SNACKBAR_TEXT_INVALID);
              return 0;
            }
            history.push({ pathname:`/brief/${id}`, state: {isNotLoggedIn : true}}, {linkView : true});
          })
        }catch(err){
          setBriefLoadInProgress(false);
          location.state.openSnackbar("Sorry, Couldn't load Brief.");
        }
      }
    }

    const loadLoginView = () => {
      history.push({
        pathname: '/'
      });
    }

    const css = `
      .load-brief-form .MuiGrid-root{
        width: 80%;
        text-align: center;
      }

      .load-brief-form label{
        font-size: 12px !important;
        transition: none !important;
        transform: none !important; 
        height: 20px !important;
        width: auto !important;
        position: relative !important;
      }

      .load-brief-form .MuiInput-formControl{
        margin-top: 0 !important;
      }
    `;

    return(
        <Grid container xs="12" md="12" direction="column" alignItems="center" justify="center" spacing={1} style={{position:'absolute',top:'8rem'}} className="load-brief-form">
          <style>
            {css}
          </style>
          <Typography variant="h6" color="primary" style={{fontWeight:'bold',textAlign:'center'}}>{LOAD_BRIEF_PAGE_TEXT.LOAD_BRIEF_HEADING}</Typography>
            <Grid item>
                <TextField
                className={uiInputClass.root}
                id="standard-full-width"
                label={LOAD_BRIEF_PAGE_TEXT.BRIEF_TEXTFIELD_LABAL_TEXT}
                style={{ margin: 8}}
                placeholder={LOAD_BRIEF_PAGE_TEXT.BRIEF_TEXTFIELD_PLACEMENT_TEXT}
                type="text"
                fullWidth
                value={sLoadBrief}
                onChange={(event) => {setLoadBrief(event.target.value)}}
                margin="normal"
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </Grid>
          <Grid item alignItems="center" justify="center" style={{textAlign:'center'}}>
            <Button variant="contained" color="primary" size="small" disabled={briefLoadInProgress} onClick={briefDispatch}>
              {(!briefLoadInProgress) ? LOAD_BRIEF_PAGE_TEXT.LOAD_BRIEF_BUTTON_TEXT : <CircularProgress size={24} />}
            </Button>
            <Divider/>
          </Grid>
          <Grid item>
            <a variant="subtitle2" onClick={loadLoginView} style={{textDecoration:'underline',cursor:'pointer'}}>{LOAD_BRIEF_PAGE_TEXT.LOG_IN_BUTTON_TEXT}</a>
          </Grid>
        </Grid>
    );

}

export default LoadBriefForm;